import * as style from './menu.css';

export default function menu() {
  return (
    <table class={style.table} cellpadding="0" cellspacing="0">
      <tr>
        <td width="10" />
        <td width="9" />
        <td width="26" />
        <td width="17" />
        <td width="45" />
        <td width="57" />
        <td width="10" />
        <td width="23" />
        <td width="13" />
      </tr>
      <tr>
        <td
          rowspan="6"
          background="/assets/img_01.jpg"
          width="10"
          height="561"
        />
        <td
          colspan="7"
          background="/assets/img_02.jpg"
          width="187"
          height="35"
        />
        <td
          rowspan="7"
          background="/assets/img_03.jpg"
          width="13"
          height="565"
        />
      </tr>
      <tr>
        <td
          colspan="2"
          background="/assets/img_04.jpg"
          width="35"
          height="103"
        />
        <td colspan="4" valign="top">
          <a href="/art" class={style.art} />
        </td>
        <td background="/assets/img_06.jpg" width="23" height="103" />
      </tr>
      <tr>
        <td background="/assets/img_07.jpg" width="9" height="101" />
        <td colspan="6" valign="top">
          <a href="/thoughts" class={style.thoughts} />
        </td>
      </tr>
      <tr>
        <td
          colspan="3"
          background="/assets/img_09.jpg"
          width="52"
          height="82"
        />
        <td colspan="2" valign="top">
          <a href="/links" class={style.links} />
        </td>
        <td
          colspan="2"
          background="/assets/img_11.jpg"
          width="33"
          height="82"
        />
      </tr>
      <tr>
        <td colspan="4" valign="top">
          <a href="/" class={style.about} />
        </td>
        <td
          colspan="3"
          background="/assets/img_13.jpg"
          width="90"
          height="151"
        />
      </tr>
      <tr>
        <td
          colspan="7"
          background="/assets/img_14.jpg"
          width="187"
          height="89"
        />
      </tr>
      <tr>
        <td
          colspan="8"
          background="/assets/img_15.jpg"
          width="197"
          height="4"
        />
      </tr>
    </table>
  );
}
